



















import { Component, Vue } from 'vue-property-decorator'
import EvaIcon from '@/components/svg-components/EvaIcon.vue'
@Component({
    components: { EvaIcon },
})
export default class BaseDropdown extends Vue {
    open = false
}
